import React from 'react';
import { motion } from 'framer-motion';

const DimensionsSection = () => {
  return (
    <section id="dimensioni" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#141414]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 text-center"
        >
          <span className="text-[#FFCC00] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-4 block">
            Dimensioni
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">
            Trova la taglia giusta
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Tre taglie per ogni esigenza. Scegli quella più adatta ai tuoi bagagli.
          </p>
        </motion.div>

        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="border-b border-[#2A2A2A]">
                <th className="text-[#FFCC00] font-semibold py-4 px-4">Taglia</th>
                <th className="text-[#FFCC00] font-semibold py-4 px-4">Dimensioni (A×L×P)</th>
                <th className="text-[#FFCC00] font-semibold py-4 px-4">Ideale per</th>
                <th className="text-[#FFCC00] font-semibold py-4 px-4">Prezzo</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-[#2A2A2A]">
                <td className="py-4 px-4">
                  <span className="bg-[#FFCC00] text-[#0A0A0A] font-bold px-3 py-1">S</span>
                  <span className="text-white ml-2">Small</span>
                </td>
                <td className="text-gray-300 py-4 px-4 font-mono">28 × 50 × 43 cm</td>
                <td className="text-gray-400 py-4 px-4">Zaino, borsa a mano, laptop bag</td>
                <td className="text-white py-4 px-4 font-bold">€1,50<span className="text-gray-500 font-normal">/ora</span></td>
              </tr>
              <tr className="border-b border-[#2A2A2A]">
                <td className="py-4 px-4">
                  <span className="bg-[#FFCC00] text-[#0A0A0A] font-bold px-3 py-1">M</span>
                  <span className="text-white ml-2">Medium</span>
                </td>
                <td className="text-gray-300 py-4 px-4 font-mono">65 × 38 × 60 cm</td>
                <td className="text-gray-400 py-4 px-4">Trolley cabina (55×35×25), borse medie</td>
                <td className="text-white py-4 px-4 font-bold">€2,00<span className="text-gray-500 font-normal">/ora</span></td>
              </tr>
              <tr>
                <td className="py-4 px-4">
                  <span className="bg-[#FFCC00] text-[#0A0A0A] font-bold px-3 py-1">XL</span>
                  <span className="text-white ml-2">Extra Large</span>
                </td>
                <td className="text-gray-300 py-4 px-4 font-mono">97 × 45 × 60 cm</td>
                <td className="text-gray-400 py-4 px-4">Valigie grandi, borsoni, attrezzatura sportiva</td>
                <td className="text-white py-4 px-4 font-bold">€3,00<span className="text-gray-500 font-normal">/ora</span></td>
              </tr>
            </tbody>
          </table>
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-gray-500 text-sm text-center mt-8"
        >
          💡 Non sai quale scegliere? <a href="https://wa.me/393773781602?text=Ciao! Ho bisogno di aiuto per scegliere la taglia del locker" className="text-[#FFCC00] hover:underline">Scrivici su WhatsApp</a> e ti aiutiamo!
        </motion.p>
      </div>
    </section>
  );
};

export default DimensionsSection;
